module.exports = __webpack_public_path__ + "static/img/logoName.b05eeb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoName.png
// module id = k7FW
// module chunks = 1